import React from 'react';

export default function EmailField({ value, onChange, mode, config, ...props }) {
    if (mode === "view") return <span>{value}</span>;
    
    return (
        <input 
            type="email" 
            value={value || ""} 
            onChange={e => onChange(e.target.value)} 
            className="form-control"
            placeholder="Enter email address"
            {...props}
        />
    );
} 